<script>
  import { Button, Modal } from 'flowbite-svelte';
  import { tick } from 'svelte';
  import { PROFILE_REMINDER } from '../lib/constants';
  import {
    createProfileModalInnerText,
    createProfileModalOpen,
    createProfileModalTitle,
  } from '../store';
  import { setCookie } from '../utils';
  import { LoadingButton } from '@button/ui';
  import ProfileForm from './forms/profile/ProfileForm.svelte';
  import { _ } from 'svelte-i18n';

  let loading = false;
  let profileForm = null;

  // Because there are no callbacks in the Modal component, keep track of whether the modal was open
  // so we can detect a close
  let wasOpen = false;

  $: {
    if ($createProfileModalOpen && !wasOpen) {
      wasOpen = true;
      tick().then(() => {
        const input = document.getElementById('fullName_profileModal');
        if (input) {
          input.focus();
        }
      });
    } else if (wasOpen) {
      wasOpen = false;
      setCookie(PROFILE_REMINDER, new Date().getTime());
    }
  }
</script>

{#if $createProfileModalOpen}
  <form on:submit={profileForm.submitForm}>
    <Modal bind:open={$createProfileModalOpen} title={$createProfileModalTitle}>
      <div class="text-gray-500">
        {$createProfileModalInnerText}
      </div>
      <ProfileForm
        bind:loading
        bind:this={profileForm}
        onSuccess={() => {
          $createProfileModalOpen = false;
        }}
      />
      <svelte:fragment slot="footer">
        <LoadingButton type="submit" bind:loading>
          {$_('components.createProfileModal.cta.updateProfile', {
            default: 'Update Profile',
          })}
        </LoadingButton>
        <Button
          type="button"
          color="alternative"
          on:click={() => ($createProfileModalOpen = false)}
        >
          {$_('components.createProfileModal.cta.remind', {
            default: 'Remind Me Later',
          })}
        </Button>
      </svelte:fragment>
    </Modal>
  </form>
{/if}
